import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AsyncRequestService } from 'src/app/core/async-request/async-request.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

import { FacebookLocation } from './shared/models';
import { FacebookLocationConnection } from './shared/models/facebook-location-connection.model';

@Injectable({
  providedIn: 'root',
})
export class FacebookLocationsService {
  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private asyncRequestService: AsyncRequestService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient
  ) {}

  fetchLocations(siteId: number): Observable<FacebookLocation[]> {
    const params = new HttpParams().append('siteId', siteId);

    return this.http
      .get<FacebookLocation[]>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/fb/locations`, { params })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  /**
   * No pipe catchAlertAndThrowHttpError here, catched in component
   */
  connectLocation(payload: FacebookLocationConnection): Observable<any> {
    return this.asyncRequestService.post<any>(
      `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/fb/locations/connect`,
      payload
    );
  }
}
